import type { TextFieldProps } from '@mui/material/TextField';

import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

import { Iconify } from '../iconify';

export type RHFTextFieldProps = TextFieldProps & {
  name: string;
  clear?: boolean;
  setSelectedUserAccDtl?: (data: any) => void;
};

export function RHFNumberField({
  name,
  helperText,
  slotProps,
  clear = false,
  setSelectedUserAccDtl = () => {},
  ...other
}: RHFTextFieldProps) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const raw = event.target.value;

          const parsed = Number(raw);
          field.onChange(isNaN(parsed) ? 0 : parsed);
        };

        const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
          const raw = event.target.value;
          const parsed = Number(raw);
          field.onChange(isNaN(parsed) ? 0 : parsed);
        };

        return (
          <TextField
            {...field}
            fullWidth
            value={typeof field.value === 'number' ? field.value : 0}
            onChange={handleChange}
            onBlur={handleBlur}
            type="number"
            error={!!error}
            helperText={error?.message ?? helperText}
            InputProps={{
              endAdornment: !!field.value && clear && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setValue(name, 0);
                      field.onChange(0);
                      setSelectedUserAccDtl({ value: '', label: '' });
                    }}
                    edge="end"
                    size="small"
                  >
                    <Iconify width={16} icon="mingcute:close-line" />
                  </IconButton>
                </InputAdornment>
              ),
              inputMode: 'decimal',
            }}
            slotProps={{
              ...slotProps,
              htmlInput: {
                autoComplete: 'off',
                inputMode: 'decimal',
                pattern: '[0-9]*',
                ...slotProps?.htmlInput,
              },
            }}
            {...other}
          />
        );
      }}
    />
  );
}
